import React from "react";
import { useBlocks } from "@jelly/lesson";
import styles from "./Page04.module.scss";

export interface Lesson0207Page04Props {
  col1Header: string;
  col1Text: string;
  col1PlayLabel: string;
  sound1Url: string;
  col2Header: string;
  col2Text: string;
  col2PlayLabel: string;
  sound2Url: string;
}

export const Lesson0207Page04: React.FC<Lesson0207Page04Props> = ({
  col1Header,
  col1Text,
  col1PlayLabel,
  sound1Url,
  col2Header,
  col2Text,
  col2PlayLabel,
  sound2Url,
}) => {
  const block = useBlocks();

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.tableWrapper}>
        <div className={styles.descriptionRow}>
          <div className={styles.col1}>
            <h2>{col1Header}</h2>
            <p>{col1Text}</p>
          </div>
          <div className={styles.col2}>
            <h2>{col2Header}</h2>
            <p>{col2Text}</p>
          </div>
        </div>
        <div className={styles.audioRow}>
          <div className={styles.col1}>
            {/* url: `${config.STATIC_ASSETS_URL}/lms/lesson/course01/lesson07/principle04/example-1.mp3`,
          text: intl.formatMessage(messages.C1_CH2_L1_P4_SoundLabel) + " 1",
          icon: "cis-volume-high",
          theme: "secondary",
          shape: "round",
          styles: {
            height: "100%",
                          }, */}
            <div className={styles.buttonWrapper}>
              <block.audioButton
                text={col1PlayLabel}
                url={sound1Url}
                icon="cis-volume-high"
                theme="secondary"
                shape="round"
              />
            </div>
          </div>
          <div className={styles.col2}>
            <div className={styles.buttonWrapper}>
              <block.audioButton
                text={col2PlayLabel}
                url={sound2Url}
                icon="cis-volume-high"
                theme="secondary"
                shape="round"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
